import { useState } from 'react';

const useOrderEventsHistory = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded((previousIsExpanded) => !previousIsExpanded);
  };

  return {
    isExpanded,
    toggleExpanded,
  };
};

export default useOrderEventsHistory;
